import React, { useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { getCategoryIconName } from '../../../utils/categoryUtils';

const VerticalCategorySidebar = ({
  categories,
  selectedCategory,
  onSelectCategory,
  categoryImages,
  theme,
  style,
}) => {
  const containerRef = useRef(null);

  // Auto-scroll active tab to vertical center of sidebar container
  useEffect(() => {
    if (!containerRef.current || !selectedCategory) return;
    
    const activeTab = document.getElementById(
      `sidebar-tab-${selectedCategory.replace(/\s+/g, '-')}`
    );
    
    if (activeTab) {
      const container = containerRef.current;
      const activeTop = activeTab.offsetTop;
      const activeHeight = activeTab.offsetHeight;
      const containerHeight = container.clientHeight;
      
      const scrollTop = activeTop - (containerHeight / 2) + (activeHeight / 2);
      container.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      });
    }
  }, [selectedCategory]);

  return (
    <div
      ref={containerRef}
      className="w-20 sm:w-24 flex-shrink-0 bg-gray-50 flex flex-col items-center py-3 overflow-y-auto [&::-webkit-scrollbar]:hidden border-r border-gray-100 select-none"
      style={style}
    >
      <div className="flex flex-col gap-3.5 w-full px-2">
        {categories.map((category) => {
          const isSelected = selectedCategory === category;
          const imgUrl = categoryImages[category];
          
          const iconName = getCategoryIconName(category);

          return (
            <button
              key={category}
              id={`sidebar-tab-${category.replace(/\s+/g, '-')}`}
              onClick={() => onSelectCategory(category)}
              className={`flex flex-col items-center gap-1.5 py-3 px-2 w-full transition-all duration-300 relative group rounded-2xl ${
                isSelected
                  ? 'text-white shadow-md scale-98 font-bold'
                  : 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'
              }`}
              style={isSelected ? {
                backgroundColor: theme?.secondary || '#16a34a',
                color: theme?.primary || '#fff',
                boxShadow: `0 4px 6px -1px ${(theme?.secondary || '#16a34a')}1A, 0 2px 4px -1px ${(theme?.secondary || '#16a34a')}0A`
              } : {}}
            >
              {/* Image Circle Container */}
              <div
                className={`w-10 h-10 sm:w-11 sm:h-11 rounded-full overflow-hidden flex items-center justify-center border-2 transition-all duration-300 ${
                  isSelected
                    ? 'border-white/40 bg-white/10'
                    : 'border-gray-200 bg-white group-hover:border-gray-300 shadow-sm'
                }`}
              >
                {imgUrl ? (
                  <img
                    src={imgUrl}
                    alt={category}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <Icon
                    name={iconName}
                    size={20}
                    color={isSelected ? '#fff' : '#6b7280'}
                    strokeWidth={isSelected ? 2 : 1.5}
                  />
                )}
              </div>

              {/* Category Name */}
              <span
                className="text-[9px] sm:text-[10px] text-center font-bold tracking-tight leading-snug break-words w-full"
                style={{
                  wordBreak: 'break-word',
                  hyphens: 'auto',
                }}
              >
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VerticalCategorySidebar;
